// Servicio de gestión de evaluaciones

import { get, post, put, del } from './api'
import { PAGINATION_CONFIG } from '../utils/constants'

export const evaluacionService = {
  /**
   * Obtener lista de evaluaciones con paginación
   * @param {object} params - Parámetros de consulta
   * @returns {Promise<object>} Lista paginada de evaluaciones
   */
  async getEvaluaciones(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        per_page: params.per_page || PAGINATION_CONFIG.DEFAULT_PAGE_SIZE,
        search: params.search || '',
        grupo_id: params.grupo_id || '',
        periodo_id: params.periodo_id || ''
      }

      const response = await get('/admin/evaluaciones', queryParams)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al obtener evaluaciones',
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: null
      }
    }
  },

  /**
   * Obtener datos del formulario (grupos, materias, períodos)
   * @returns {Promise<object>} Datos del formulario
   */
  async getDatosFormulario() {
    try {
      const response = await get('/admin/evaluaciones/datos-formulario')
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || {},
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al obtener datos del formulario',
          data: {}
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: {}
      }
    }
  },

  /**
   * Obtener evaluaciones por grupo y período
   * @param {number} grupoId - ID del grupo
   * @param {number} periodoId - ID del período
   * @returns {Promise<object>} Evaluaciones del grupo y período
   */
  async getEvaluacionesPorGrupoYPeriodo(grupoId, periodoId) {
    try {
      const response = await get(`/admin/evaluaciones/por-grupo-periodo/${grupoId}/${periodoId}`)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || [],
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al obtener evaluaciones',
          data: []
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: []
      }
    }
  },

  /**
   * Crear nueva evaluación
   * @param {object} data - Datos de la evaluación
   * @returns {Promise<object>} Evaluación creada
   */
  async createEvaluacion(data) {
    try {
      const response = await post('/admin/evaluaciones', data)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al crear evaluación',
          errors: response.data?.errors || null,
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        errors: error.response?.data?.errors || null,
        data: null
      }
    }
  },

  /**
   * Obtener evaluación por ID
   * @param {number} id - ID de la evaluación
   * @returns {Promise<object>} Evaluación solicitada
   */
  async getEvaluacion(id) {
    try {
      const response = await get(`/admin/evaluaciones/${id}`)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Evaluación no encontrada',
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: null
      }
    }
  },

  /**
   * Actualizar evaluación
   * @param {number} id - ID de la evaluación
   * @param {object} data - Datos a actualizar
   * @returns {Promise<object>} Evaluación actualizada
   */
  async updateEvaluacion(id, data) {
    try {
      const response = await put(`/admin/evaluaciones/${id}`, data)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al actualizar evaluación',
          errors: response.data?.errors || null,
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        errors: error.response?.data?.errors || null,
        data: null
      }
    }
  },

  /**
   * Eliminar evaluación
   * @param {number} id - ID de la evaluación
   * @returns {Promise<object>} Resultado de la eliminación
   */
  async deleteEvaluacion(id) {
    try {
      const response = await del(`/admin/evaluaciones/${id}`)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al eliminar evaluación'
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión'
      }
    }
  }
}
